"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconUndo', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M11 4.50025C8 4.50025 3.45 4.50025 3.45 4.50025L5.243 2.70725C5.633 2.31625 5.633 1.68425 5.243 1.29325C4.852 0.90225 4.219 0.90225 3.829 1.29325L0.403 4.71925C0.164 4.90225 0 5.17625 0 5.50025C0 5.50625 0.00300002 5.51125 0.00300002 5.51825C-0.000999979 5.77925 0.093 6.04225 0.293 6.24325L3.829 9.77825C4.024 9.97425 4.28 10.0712 4.536 10.0712C4.792 10.0712 5.047 9.97425 5.243 9.77825C5.633 9.38825 5.633 8.75525 5.243 8.36425L3.378 6.50025C3.378 6.50025 9 6.50025 11 6.50025C13 6.50025 14 7.5 14 9.50025C14 11.5005 13 12.5002 11 12.5002C9 12.5002 10 12.5002 10 12.5002C9.448 12.5002 9 12.9472 9 13.5002C9 14.0532 9.448 14.5002 10 14.5002C10 14.5002 8 14.5002 11 14.5002C14 14.5002 16 12.5005 16 9.50025C16 6.5 14 4.50025 11 4.50025Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M13 5.00025H4.45L6.243 3.20725C6.633 2.81625 6.633 2.18425 6.243 1.79325C5.852 1.40225 5.219 1.40225 4.829 1.79325L1.403 5.21925C1.164 5.40225 1 5.67625 1 6.00025C1 6.00625 1.003 6.01125 1.003 6.01825C0.999 6.27925 1.093 6.54225 1.293 6.74325L4.829 10.2782C5.024 10.4742 5.28 10.5712 5.536 10.5712C5.792 10.5712 6.047 10.4742 6.243 10.2782C6.633 9.88825 6.633 9.25525 6.243 8.86425L4.378 7.00025H13C15.206 7.00025 17 8.79425 17 11.0002C17 13.2062 15.206 15.0002 13 15.0002H10C9.448 15.0002 9 15.4472 9 16.0002C9 16.5532 9.448 17.0002 10 17.0002H13C16.309 17.0002 19 14.3092 19 11.0002C19 7.69125 16.309 5.00025 13 5.00025'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M15.6 6.0003H5.34001L7.49161 3.8487C7.95961 3.3795 7.95961 2.6211 7.49161 2.1519C7.02241 1.6827 6.26281 1.6827 5.79481 2.1519L1.68361 6.2631C1.39681 6.4827 1.20001 6.8115 1.20001 7.2003C1.20001 7.2075 1.20361 7.2135 1.20361 7.2219C1.19881 7.5351 1.31161 7.8507 1.55161 8.0919L5.79481 12.3339C6.02881 12.5691 6.33601 12.6855 6.64321 12.6855C6.95041 12.6855 7.25641 12.5691 7.49161 12.3339C7.95961 11.8659 7.95961 11.1063 7.49161 10.6371L5.25361 8.4003H15.6C18.2472 8.4003 20.4 10.5531 20.4 13.2003C20.4 15.8475 18.2472 18.0003 15.6 18.0003H12C11.3376 18.0003 10.8 18.5367 10.8 19.2003C10.8 19.8639 11.3376 20.4003 12 20.4003H15.6C19.5708 20.4003 22.8 17.1711 22.8 13.2003C22.8 9.2295 19.5708 6.0003 15.6 6.0003'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M20.8 8.0004H7.11998L9.98878 5.1316C10.6128 4.506 10.6128 3.4948 9.98878 2.8692C9.36318 2.2436 8.35038 2.2436 7.72638 2.8692L2.24478 8.3508C1.86238 8.6436 1.59998 9.082 1.59998 9.6004C1.59998 9.61 1.60478 9.618 1.60478 9.6292C1.59838 10.0468 1.74878 10.4676 2.06878 10.7892L7.72638 16.4452C8.03838 16.7588 8.44797 16.914 8.85757 16.914C9.26717 16.914 9.67518 16.7588 9.98878 16.4452C10.6128 15.8212 10.6128 14.8084 9.98878 14.1828L7.00478 11.2004H20.8C24.3296 11.2004 27.2 14.0708 27.2 17.6004C27.2 21.13 24.3296 24.0004 20.8 24.0004H16C15.1168 24.0004 14.4 24.7156 14.4 25.6004C14.4 26.4852 15.1168 27.2004 16 27.2004H20.8C26.0944 27.2004 30.4 22.8948 30.4 17.6004C30.4 12.306 26.0944 8.0004 20.8 8.0004'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;